// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ForgeProjectContext {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.designSystemId = model.designSystemId;
        this.name = model.name;
        this.description = model.description;
        this.productContext = model.productContext;
        this.componentSet = model.componentSet;
        this.iconSet = model.iconSet;
        this.additionalContext = model.additionalContext;
        this.theme = model.theme;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.isArchived = model.isArchived;
        this.isAllowedInPortal = model.isAllowedInPortal;
        this.isFeedbackCollectionEnabled = model.isFeedbackCollectionEnabled;
        this.isFeedbackCollectionAnonymous = model.isFeedbackCollectionAnonymous;
        this.isLibraryDismissed = (_a = model.isLibraryDismissed) !== null && _a !== void 0 ? _a : false;
        this.themePreset = model.themePreset;
        this.defaultTokenThemeSetId = model.defaultTokenThemeSetId;
        this.tokenThemeSets = (_b = model.tokenThemeSets) !== null && _b !== void 0 ? _b : [];
        this.scope = model.scope;
        this.mcpUrlSlug = model.mcpUrlSlug;
        this.brandId = model.brandId;
        this.thumbnail = model.thumbnail;
        this.sandboxTemplate = model.sandboxTemplate;
        this.includedContextIds = (_c = model.includedContextIds) !== null && _c !== void 0 ? _c : [];
        this.includedByContextIds = (_d = model.includedByContextIds) !== null && _d !== void 0 ? _d : [];
    }
    toRemote() {
        return this;
    }
}
